import api from '@/utils/api'

export default {
    // the bracket made in the CMS for the playoffs of a league, or for the cup of the season; empty when none is made
    getBracket({ seasonId, leagueId, cup, cupLeagueId }) {
        const params = [`seasonId=${seasonId}`]
        if (cup) params.push('cup=true')
        if (leagueId && !cup) params.push(`leagueId=${leagueId}`)
        if (cupLeagueId) params.push(`cupLeagueId=${cupLeagueId}`)
        return api.get(`brackets?${params.join('&')}`)
    }
}
